import { render, staticRenderFns } from "./FreeHeroPartner.vue?vue&type=template&id=284a28d2&scoped=true&"
import script from "./FreeHeroPartner.vue?vue&type=script&lang=js&"
export * from "./FreeHeroPartner.vue?vue&type=script&lang=js&"
import style0 from "./FreeHeroPartner.vue?vue&type=style&index=0&id=284a28d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a28d2",
  null
  
)

export default component.exports